import React from 'react';
import { EyeOff, Play } from 'lucide-react';
import { useRedGifsPoster } from '@/lib/useRedGifs';

// RedGifs preview for a clip, with a hatched tile when there's no image
export const ClipThumb: React.FC<{ url?: string; className?: string; showPlay?: boolean }> = ({ url, className = 'w-16 h-16', showPlay }) => {
  const { src, onError, failed } = useRedGifsPoster(url);
  const hasImage = !!src && !failed;
  return (
    <span className={`${className} relative shrink-0 rounded-[14px] overflow-hidden clip-thumb-fallback text-ink-muted flex items-center justify-center`} aria-hidden="true">
      {hasImage && (
        <img
          src={src}
          alt=""
          loading="lazy"
          referrerPolicy="no-referrer"
          onError={onError}
          className="absolute inset-0 w-full h-full object-cover"
        />
      )}
      {showPlay ? (
        <span className={`relative flex items-center justify-center ${hasImage ? 'w-7 h-7 rounded-full bg-ground/60 text-ink' : ''}`}>
          <Play className="w-[14px] h-[14px] fill-current" />
        </span>
      ) : (
        !hasImage && <EyeOff className="relative w-5 h-5" />
      )}
    </span>
  );
};
